// extracted by mini-css-extract-plugin
export default {"liffMessenger":"Customer_liffMessenger__O+hW0","btnDiv":"Customer_btnDiv__TV0XA","btnLogout":"Customer_btnLogout__pMVYZ"};